<template>
  <div class="product-carousel critical-component-clear">
    <content-carousel
      :cards="products"
      carousel-pagination
      has-details-animation
      :title="title"
      :show-badges="false"
      :show-caviar-description="false"
      container-class="l2-11"
      :quickview="quickview"
    />
  </div>
</template>

<script>

/**
 * Vue: Product carousel (product-carousel)
 * -----------------------------------------------------------------------------
 * Product carousel section with header and product cards.
 * - Component settings: section / dynamic / async / scroll
 *
 * @param {String} [title] - Title text.
 * @param {Array} products - Array of products
 *
 */
import ContentCarousel from '~async/content-carousel/content-carousel.vue'

export default {
  name: 'ProductCarousel',

  components: { ContentCarousel },

  props: {
    title: {
      type: String,
      default: '',
    },
    products: {
      type: Array,
      default: () => [],
    },
    quickview: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
@import './product-carousel';
</style>
